import { isShopifyMerchant } from './shopifyExternalId';

/** Normalize a BigCommerce store hash from raw user input. */
export const normalizeBigCommerceExternalId = (raw: string): string | null => {
  const trimmed = raw.trim().toLowerCase();
  if (!trimmed) {
    return null;
  }

  return /^[a-z0-9]+$/u.test(trimmed) ? trimmed : null;
};

export const BIGCOMMERCE_EXTERNAL_PLATFORM_ID_MISMATCH_ERROR =
  'Store hash does not match this merchant.';

/** True when this merchant is bound to a BigCommerce store hash. */
export const isBigCommerceMerchant = (externalPlatformId?: string | null): boolean =>
  Boolean(externalPlatformId && normalizeBigCommerceExternalId(externalPlatformId)) &&
  !isShopifyMerchant(externalPlatformId);

export const getBigCommerceExternalPlatformIdMismatchError = (
  storeHash: string,
  merchantExternalPlatformId?: string | null,
): string | undefined => {
  const normalizedStoreHash = normalizeBigCommerceExternalId(storeHash);
  if (!normalizedStoreHash || !merchantExternalPlatformId) {
    return undefined;
  }

  const normalizedMerchantId =
    normalizeBigCommerceExternalId(merchantExternalPlatformId) ??
    merchantExternalPlatformId.trim().toLowerCase();

  if (normalizedStoreHash === normalizedMerchantId) {
    return undefined;
  }

  return BIGCOMMERCE_EXTERNAL_PLATFORM_ID_MISMATCH_ERROR;
};
